module.exports = __webpack_public_path__ + "static/media/2019-03-02-01.f264159e.png";